import { convertNumberToUSFormat } from '@utils/Util';

export const formatQuotationUsd = (value) => {
	if (value === null || value === undefined || value === '') {
		return '—';
	}
	const n = Number(value);
	if (Number.isNaN(n)) {
		return '—';
	}
	return `$${convertNumberToUSFormat(n, false, false)}`;
};

export const groupConsecutiveSizePrices = (rows) => {
	if (!Array.isArray(rows) || rows.length === 0) return [];

	const groups = [];
	let i = 0;
	while (i < rows.length) {
		const start = i;
		const price = Number(rows[i].price);
		while (i + 1 < rows.length && Number(rows[i + 1].price) === price) {
			i++;
		}
		const from = rows[start];
		const to = rows[i];
		const fromSize = from?.sizeLabel || from?.name || '';
		const toSize = to?.sizeLabel || to?.name || '';
		const label = start === i ? fromSize : `${fromSize}-${toSize}`;
		groups.push({ label, price });
		i++;
	}
	return groups;
};

export const groupColorsByPrice = (rows) => {
	if (!Array.isArray(rows) || rows.length === 0) return [];

	const sorted = [...rows].sort((a, b) => Number(a.colorId || 0) - Number(b.colorId || 0));
	const priceLineOrder = [];
	const namesByPrice = new Map();

	for (const row of sorted) {
		const price = Number(row.price);
		if (!namesByPrice.has(price)) {
			namesByPrice.set(price, []);
			priceLineOrder.push(price);
		}
		namesByPrice.get(price).push(row?.name || row?.colorName || row?.colorLabel || '');
	}

	return priceLineOrder.map((price) => ({
		namesJoined: namesByPrice.get(price).filter(Boolean).join(', '),
		price
	}));
};
